import { Flex, Heading, Box } from '@chakra-ui/core'
import { StoryList } from 'components/shared/StoryList'
import { getStoryRelatedStories } from "data/api/ApiStory";

export function RelatedStories({ story }) {
  const relatedStories = getStoryRelatedStories(story);
  console.log("related stories", relatedStories); 
  return (
    relatedStories.length > 0 && (
      <Flex
        flexGrow={1}
        w="100%"
        zIndex={1}
        position="relative"
        margin="0"
        flexDirection="column"
        bg="gray.100"
        alignItems="center"
      >
        <Flex flexGrow={1} flexDirection="column" m={[1, 3, 7]}>
          <Heading fontSize={["xl", "xl", "2xl"]} m={3}>
            Related Stories
          </Heading>
          <Box
            w="100%"
            h="10px"
            backgroundSize="contain"
            backgroundPosition="center"
            backgroundRepeat="no-repeat"
            backgroundImage="url(/static/squiggly.png)"
          />
        </Flex>
        <Flex position="relative" bg="gray.100" w="100%">
          <StoryList useSingleColumn stories={relatedStories} />
        </Flex>
      </Flex>
    )
  );
}
